import script from "./TransferReceiveLightPage.vue?vue&type=script&setup=true&lang=js"
export * from "./TransferReceiveLightPage.vue?vue&type=script&setup=true&lang=js"

import "./TransferReceiveLightPage.vue?vue&type=style&index=0&id=2cce7cb5&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2cce7cb5"]])

export default __exports__